"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4638],{

/***/ 59433:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ AccordionList; }
/* harmony export */ });
/* unused harmony export SeeAllLink */
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29254);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _core_index_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8013);
/* harmony import */ var _core_index_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93298);
/* harmony import */ var _core_index_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4796);
/* harmony import */ var _core_index_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47208);
/* harmony import */ var _core_Icon_Icon_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49154);
/* harmony import */ var _core_List_AccordionListItem_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55662);
/* harmony import */ var _hooks_useMedia_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61151);
function cov_253a01gitz() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Accordion/AccordionList.tsx";
  var hash = "6b576b139f6b90ed3f657b2faffd33a6a864409d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Accordion/AccordionList.tsx",
    statementMap: {
      "0": {
        start: {
          line: 70,
          column: 60
        },
        end: {
          line: 108,
          column: 1
        }
      },
      "1": {
        start: {
          line: 78,
          column: 2
        },
        end: {
          line: 107,
          column: 4
        }
      },
      "2": {
        start: {
          line: 95,
          column: 10
        },
        end: {
          line: 103,
          column: 16
        }
      },
      "3": {
        start: {
          line: 114,
          column: 53
        },
        end: {
          line: 131,
          column: 1
        }
      },
      "4": {
        start: {
          line: 115,
          column: 23
        },
        end: {
          line: 115,
          column: 34
        }
      },
      "5": {
        start: {
          line: 116,
          column: 2
        },
        end: {
          line: 130,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 70,
            column: 60
          },
          end: {
            line: 70,
            column: 61
          }
        },
        loc: {
          start: {
            line: 77,
            column: 6
          },
          end: {
            line: 108,
            column: 1
          }
        },
        line: 77
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 94,
            column: 30
          },
          end: {
            line: 94,
            column: 31
          }
        },
        loc: {
          start: {
            line: 95,
            column: 10
          },
          end: {
            line: 103,
            column: 16
          }
        },
        line: 95
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 114,
            column: 53
          },
          end: {
            line: 114,
            column: 54
          }
        },
        loc: {
          start: {
            line: 114,
            column: 82
          },
          end: {
            line: 131,
            column: 1
          }
        },
        line: 114
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 18
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 75,
            column: 13
          },
          end: {
            line: 75,
            column: 18
          }
        }],
        line: 75
      },
      "1": {
        loc: {
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 76,
            column: 22
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 76,
            column: 22
          }
        }],
        line: 76
      },
      "2": {
        loc: {
          start: {
            line: 80,
            column: 7
          },
          end: {
            line: 89,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 80,
            column: 13
          }
        }, {
          start: {
            line: 80,
            column: 17
          },
          end: {
            line: 80,
            column: 21
          }
        }, {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 88,
            column: 15
          }
        }],
        line: 80
      },
      "3": {
        loc: {
          start: {
            line: 82,
            column: 11
          },
          end: {
            line: 86,
            column: 18
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 83,
            column: 12
          },
          end: {
            line: 85,
            column: 19
          }
        }, {
          start: {
            line: 86,
            column: 14
          },
          end: {
            line: 86,
            column: 18
          }
        }],
        line: 82
      },
      "4": {
        loc: {
          start: {
            line: 87,
            column: 11
          },
          end: {
            line: 87,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 87,
            column: 18
          },
          end: {
            line: 87,
            column: 74
          }
        }, {
          start: {
            line: 87,
            column: 77
          },
          end: {
            line: 87,
            column: 81
          }
        }],
        line: 87
      },
      "5": {
        loc: {
          start: {
            line: 91,
            column: 22
          },
          end: {
            line: 91,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 91,
            column: 46
          },
          end: {
            line: 91,
            column: 52
          }
        }, {
          start: {
            line: 91,
            column: 55
          },
          end: {
            line: 91,
            column: 68
          }
        }],
        line: 91
      },
      "6": {
        loc: {
          start: {
            line: 92,
            column: 25
          },
          end: {
            line: 92,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 92,
            column: 49
          },
          end: {
            line: 92,
            column: 60
          }
        }, {
          start: {
            line: 92,
            column: 63
          },
          end: {
            line: 92,
            column: 75
          }
        }],
        line: 92
      },
      "7": {
        loc: {
          start: {
            line: 100,
            column: 25
          },
          end: {
            line: 100,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 100,
            column: 56
          },
          end: {
            line: 100,
            column: 70
          }
        }, {
          start: {
            line: 100,
            column: 73
          },
          end: {
            line: 100,
            column: 94
          }
        }],
        line: 100
      },
      "8": {
        loc: {
          start: {
            line: 127,
            column: 57
          },
          end: {
            line: 127,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 127,
            column: 68
          },
          end: {
            line: 127,
            column: 70
          }
        }, {
          start: {
            line: 127,
            column: 73
          },
          end: {
            line: 127,
            column: 75
          }
        }],
        line: 127
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6b576b139f6b90ed3f657b2faffd33a6a864409d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_253a01gitz = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_253a01gitz();

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }







/**
 * Component that stacks accordions ontop of each other Font for heading &
 * see-all link will update based on device used to view accordion Developer can
 * optionally pass a title to render a title on accordionList Developer can
 * optionally pass a link to render a "See all" link that directs user to
 * another page for more information If using AccordionList in a bundle
 * sensitive application (example: Cosmos) that uses Selective Spritesheet you
 * must import - ChevronDown16 to get the chevron to appear
 *
 * An accordion is a vertically stacked list of headers that reveal or hide
 * associated sections of content.
 *
 * AccordionList size variations
 * ------------------------------------------------------------------------------------------------------------
 *
 * "standard"
 *
 * "compact"
 *
 *
 * ## Analytics
 *
 * `AccordionList`is set up to track impressions and click events:
 *
 * * ClickEvents - pass the analyticsName List to track the accordion click
 * event
 *
 * * ImpressionEvents - pass `trackImpression={true}` to List to track the
 * impression event
 *
 * Note: We do not track impressions directly on AccordionListItem but track
 * impression events on List
 * ([AccordionListWithTracking](https://github.com/opendoor-labs/code/blob/master/js/packages/bricks/src/core/List/List.tsx#LL94C18-L94C18)).
 * This way we track the view event for the accordion as a whole instead of for
 * each accordion panel.
 *
 * Events will be sent to journey service and will end up in the corresponding
 * tables (e.g. journey\_service\_production.platform\_accordion\_click\_event
 * for accordion click events)
 *
 * * For more information on tracking please refer here:
 * [https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 */
cov_253a01gitz().s[0]++;
var AccordionList = function AccordionList(_ref) {
  var analyticsName = _ref.analyticsName,
    listOfAccordions = _ref.listOfAccordions,
    title = _ref.title,
    link = _ref.link,
    _ref$wrapText = _ref.wrapText,
    wrapText = _ref$wrapText === void 0 ? (cov_253a01gitz().b[0][0]++, false) : _ref$wrapText,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? (cov_253a01gitz().b[1][0]++, 'standard') : _ref$variant;
  cov_253a01gitz().f[0]++;
  cov_253a01gitz().s[1]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    width: "100%"
  }, ((cov_253a01gitz().b[2][0]++, title) || (cov_253a01gitz().b[2][1]++, link)) && (cov_253a01gitz().b[2][2]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    justifyContent: "space-between",
    pb: 5
  }, title ? (cov_253a01gitz().b[3][0]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    fontSize: "s2",
    fontWeight: "semibold",
    color: "neutrals90"
  }, title)) : (cov_253a01gitz().b[3][1]++, null), link ? (cov_253a01gitz().b[4][0]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(SeeAllLink, {
    link: link,
    analyticsName: analyticsName
  })) : (cov_253a01gitz().b[4][1]++, null))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    borderRadius: variant === 'compact' ? (cov_253a01gitz().b[5][0]++, 'none') : (cov_253a01gitz().b[5][1]++, 'semiRounded'),
    backgroundColor: variant === 'compact' ? (cov_253a01gitz().b[6][0]++, 'neutrals0') : (cov_253a01gitz().b[6][1]++, 'neutrals10')
  }, listOfAccordions.map(function (item, index) {
    cov_253a01gitz().f[1]++;
    cov_253a01gitz().s[2]++;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      key: "item-".concat(index)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_List_AccordionListItem_mjs__WEBPACK_IMPORTED_MODULE_7__/* .AccordionListItem */ .rB, _extends({
      analyticsName: analyticsName,
      wrapText: wrapText
      // if item.noPadding is specified, use that, if not, set if compact
      ,
      noPadding: item.noPadding !== undefined ? (cov_253a01gitz().b[7][0]++, item.noPadding) : (cov_253a01gitz().b[7][1]++, variant === 'compact')
    }, item)));
  })));
};

/**
 * Component that handles opening up a new page for more information
 * Will only appear if a link is passed through to AccordionList
 */
cov_253a01gitz().s[3]++;
var SeeAllLink = function SeeAllLink(_ref2) {
  var link = _ref2.link,
    analyticsName = _ref2.analyticsName;
  cov_253a01gitz().f[2]++;
  var _ref3 = (cov_253a01gitz().s[4]++, (0,_hooks_useMedia_mjs__WEBPACK_IMPORTED_MODULE_8__/* .useDevice */ .F)()),
    isMobile = _ref3.isMobile;
  cov_253a01gitz().s[5]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    justifyContent: "flex-end"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_index_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    href: link,
    target: "_blank",
    fontWeight: "semibold",
    fontSize: ['s0', 's0', 's2', 's2'],
    analyticsName: analyticsName,
    "aria-label": 'Select to get more information'
  }, "See all", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_core_Icon_Icon_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
    name: "chevron-right",
    color: "brand50",
    size: isMobile ? (cov_253a01gitz().b[8][0]++, 12) : (cov_253a01gitz().b[8][1]++, 16)
  })));
};

/***/ }),

/***/ 87583:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SelectiveSpritesheet; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68309);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26153);
function cov_zw7tn39gn() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SelectiveSpritesheet.tsx";
  var hash = "66568fe6bb99f1c867cb09b7696a79e88f8d33cc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SelectiveSpritesheet.tsx",
    statementMap: {
      "0": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 32,
          column: 4
        }
      },
      "1": {
        start: {
          line: 28,
          column: 10
        },
        end: {
          line: 28,
          column: 78
        }
      }
    },
    fnMap: {
      "0": {
        name: "SelectiveSpritesheet",
        decl: {
          start: {
            line: 18,
            column: 24
          },
          end: {
            line: 18,
            column: 44
          }
        },
        loc: {
          start: {
            line: 23,
            column: 3
          },
          end: {
            line: 33,
            column: 1
          }
        },
        line: 23
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 27,
            column: 25
          },
          end: {
            line: 27,
            column: 26
          }
        },
        loc: {
          start: {
            line: 28,
            column: 10
          },
          end: {
            line: 28,
            column: 78
          }
        },
        line: 28
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "66568fe6bb99f1c867cb09b7696a79e88f8d33cc"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_zw7tn39gn = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_zw7tn39gn();




/**
 * Spritesheet component that allows for selective imports of different
 * Spritesheet icons.
 *
 * This can be used with any of the ./Icon/* imports.
 * Most often used in bundle sensitive applications (example: Cosmos)
 *
 * Usage:
 * import ChevronDown16 from '@opendoor/bricks/core/Icon/SpriteSheetIcons/ChevronDown16'
 *
 * <SelectiveSpritesheet icons={[ChevronDown16]}>
 */
function SelectiveSpritesheet(props) {
  cov_zw7tn39gn().f[0]++;
  cov_zw7tn39gn().s[0]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_3__/* .bricks.svg */ .G.svg, {
    opacity: 0,
    width: 0,
    height: 0,
    display: "block",
    "aria-hidden": "true"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("defs", null, props.icons.map(function (_ref) {
    var name = _ref.name,
      svg = _ref.svg;
    cov_zw7tn39gn().f[1]++;
    cov_zw7tn39gn().s[1]++;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("g", {
      key: name,
      id: name,
      dangerouslySetInnerHTML: {
        __html: svg
      }
    });
  })));
}

/***/ }),

/***/ 18070:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

function cov_1lu1rsgtpd() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronDown.tsx";
  var hash = "70ab844cf3ee04b49a54a20701a1141c5bc163a3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronDown.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "70ab844cf3ee04b49a54a20701a1141c5bc163a3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1lu1rsgtpd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1lu1rsgtpd();
var Icon = (cov_1lu1rsgtpd().s[0]++, {
  name: 'chevron-down',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.7808 7.0239C19.3199 7.45516 19.4073 8.24178 18.976 8.78085L12.976 16.2809C12.7388 16.5774 12.3797 16.75 12 16.75C11.6202 16.75 11.2611 16.5774 11.0239 16.2809L5.02387 8.78085C4.59261 8.24178 4.68001 7.45516 5.21909 7.0239C5.75816 6.59264 6.54478 6.68004 6.97604 7.21912L12 13.499L17.0239 7.21912C17.4551 6.68004 18.2417 6.59264 18.7808 7.0239Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ }),

/***/ 86348:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

function cov_1m4ayordkx() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronRight.tsx";
  var hash = "8bc5d27d1b71da2697b9377c2e1daa79b0844106";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronRight.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8bc5d27d1b71da2697b9377c2e1daa79b0844106"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1m4ayordkx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1m4ayordkx();
var Icon = (cov_1m4ayordkx().s[0]++, {
  name: 'chevron-right',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M15.8308 11.9921L8.29809 4.45942C8.09938 4.26071 8.00258 4.02673 8.00772 3.7575C8.01285 3.48828 8.11478 3.25432 8.31349 3.0556C8.51219 2.85688 8.74616 2.75752 9.01539 2.75752C9.28463 2.75752 9.51859 2.85688 9.71729 3.0556L17.3884 10.7114C17.5692 10.8921 17.7032 11.0947 17.7904 11.319C17.8776 11.5434 17.9211 11.7678 17.9211 11.9921C17.9211 12.2165 17.8776 12.4408 17.7904 12.6652C17.7032 12.8896 17.5692 13.0921 17.3884 13.2729L9.71729 20.944C9.51859 21.1427 9.28206 21.2395 9.00769 21.2344C8.73334 21.2293 8.49681 21.1274 8.29809 20.9287C8.09938 20.7299 8.00002 20.496 8.00002 20.2268C8.00002 19.9575 8.09938 19.7235 8.29809 19.5248L15.8308 11.9921Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ }),

/***/ 80270:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

function cov_rkb62rso3() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Close16.tsx";
  var hash = "a323f52c1aef9a5062973d317fc7a0b967804b6d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Close16.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 48
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a323f52c1aef9a5062973d317fc7a0b967804b6d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_rkb62rso3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_rkb62rso3();
var Icon = (cov_rkb62rso3().s[0]++, {
  name: 'close-16',
  svg: "<path d=\"M10.6515 12.4191C11.1397 12.9072 11.9312 12.9072 12.4193 12.4191C12.9075 11.9309 12.9075 11.1395 12.4193 10.6513L9.76804 8.00003L12.4193 5.34875C12.9075 4.86059 12.9075 4.06914 12.4193 3.58098C11.9312 3.09283 11.1397 3.09283 10.6515 3.58098L8.00027 6.23226L5.34824 3.58023C4.86008 3.09207 4.06863 3.09207 3.58047 3.58023C3.09232 4.06838 3.09232 4.85984 3.58047 5.34799L6.2325 8.00002L3.58048 10.652C3.09232 11.1402 3.09232 11.9317 3.58048 12.4198C4.06863 12.908 4.86009 12.908 5.34824 12.4198L8.00027 9.76779L10.6515 12.4191Z\" fill=\"currentColor\"/>"
});
/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ })

}]);